module.exports = require("core-js/library/fn/object/set-prototype-of");